import * as React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemTitle,
  ListItemActions,
  Modal
} from '../../../Components';
import { Tag } from '../../../Components/Tag/Tag';
import { MonografiaModel } from '../../../Store';
import { SituacaoDoDeposito } from '../../../Store/Deposito';
import styled from 'styled-components';
import AlterarNotaModal from '../../Funcionario/Components/AlterarNotaModal';

interface IProps {
  monografias: MonografiaModel[];
  resetOnRedirect: () => void;
  atribuirNota: boolean;
  onTextChange?: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onTextNCChange?: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onTextObsChange?: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onAutorizacaoChange?: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onAprovar?: (monografiaId: number, notaO: number|undefined, 
    notaC: number|undefined, obs: string|undefined, aut: boolean|undefined) => any
  notaOValida?: boolean|undefined, notaCValida?: boolean|undefined,
}

const StyledTags = styled.div`
  flex-direction: row;
`;

const StyledItem = styled(ListItem)`
  display: flex;
`;

export const MonografiasCard: React.FC<IProps> = ({
  monografias, atribuirNota, onTextChange, onTextNCChange, onTextObsChange, 
  onAutorizacaoChange, onAprovar, notaOValida, notaCValida }: IProps) => {
  const [open, setOpen] = React.useState(false);
  const [monografia, setMonografia] = React.useState<MonografiaModel>();

  function abrirModal(m: MonografiaModel){
    setOpen(true)
    setMonografia(m)
  }

  return(
  <List showBorder={false}>
    {monografias &&
      monografias.map((m, i) => (
        <>
        {onTextChange && onTextNCChange && onTextObsChange && onAutorizacaoChange && onAprovar && monografia &&
        <Modal 
          size={"large"} 
          isVisible={open} 
          outterClick={()=>setOpen(false)}>
          <AlterarNotaModal 
            monografia={monografia}
            onTextChange={onTextChange}
            onTextNCChange={onTextNCChange}
            onTextObsChange={onTextObsChange}
            onAutorizacaoChange={onAutorizacaoChange}
            onAprovar={onAprovar}
            notaOValida={notaOValida}
            notaCValida={notaCValida}
          />
      </Modal>
      }
        <StyledItem
          key={i}
          onClick={() => (
            !atribuirNota ?
            (window.location.pathname =
              m.deposito && m.deposito.situacao !== 1
                ? `professor/monografia/${m.id}`
                : `professor/agendamento/${m.id}`)
                : abrirModal(m)
      )}
        >
          <ListItemTitle>{m.aluno.nome}</ListItemTitle>
          <ListItemText>{m.titulo}</ListItemText>
          <ListItemActions>
            <StyledTags>
              {(() => {
                switch (m.deposito!.situacao) {
                  case SituacaoDoDeposito.aprovado:
                    return <Tag color='approvedColor'>Depósito aceito</Tag>;
                  case SituacaoDoDeposito.pendente:
                    return <Tag color='primaryColor'>Avaliação pendente</Tag>;
                  case SituacaoDoDeposito.reprovado:
                    return <Tag color='errorColor'>Depósito rejeitado</Tag>;
                  default:
                    return <Tag color='primaryColor'>Avaliação pendente</Tag>;
                }
              })()}
              {m.agendamento ?
                <Tag color='approvedColor'>Agendamento realizado</Tag>
                : m.dataDeApresentacaoSugerida ?
                  <Tag>Agendamento solicitado</Tag>
                  :
                  <Tag>Agendamento pendente</Tag>
              }
            </StyledTags>
          </ListItemActions>
        </StyledItem>
        </>
      ))}
  </List>
)}